import React, { useEffect } from 'react';

import { useGetMirAccountWarehousesMutation } from '@apis/materialsInReview/MaterialsInReview.api';
import { PanelBlock } from '@molecules/panelBlock/PanelBlock';
import { LocateProductFilters } from '@organisms/locateProducts/LocateProductFilters';
import styles from 'components/UI/organisms/trackOrders/orderList/OrdersList.module.less';

import { useLocateProductTemplate } from './useLocateProductTemplate';

export const LocateProductTemplate = () => {
    const [
        getMirAccountWarehouses,
        { data: warehousesData, isLoading: isWarehousesLoading }
    ] = useGetMirAccountWarehousesMutation();

    const {
        selectedWarehouses,
        onRemoveWarehouse,
        onApplyWarehouses,
        clearFilters
    } = useLocateProductTemplate();

    useEffect(() => {
        getMirAccountWarehouses();
    }, []);

    const title = 'Locate Product';

    return (
        <PanelBlock
            title={title}
            hideHeaderOnMobile={false}
            isFullWidthOnSmallDesktop
        >
            <div className={styles.Container}>
                <LocateProductFilters
                    warehousesData={warehousesData}
                    styles={styles}
                    isWarehousesLoading={isWarehousesLoading}
                    selectedWarehouses={selectedWarehouses}
                    onRemoveWarehouse={onRemoveWarehouse}
                    onApplyWarehouses={onApplyWarehouses}
                    onClearFilters={clearFilters}
                >
                    <div></div>
                </LocateProductFilters>
            </div>
        </PanelBlock>
    );
};
